<template>
  <admin-card title="Создание курса" :show-partners-block="false">
    <form @submit.prevent="create" @keydown="form.onKeydown($event)">
      <!-- Course Title -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('course_title') }}</label>
        <div class="col-md-7">
          <input v-model="form.title" type="text" name="title" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('title') }">
          <has-error :form="form" field="title"></has-error>
        </div>
      </div>

      <!-- About course -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('course_about') }}</label>
        <div class="col-md-7">
          <input v-model="form.about" type="text" name="about" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('about') }">
          <has-error :form="form" field="about"></has-error>
        </div>
      </div>

      <!-- Lessons counter string -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('course_lessons_counter') }}</label>
        <div class="col-md-7">
          <input v-model="form.lessons_counter" type="text" name="about" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('lessons_counter') }">
          <has-error :form="form" field="lessons_counter"></has-error>
        </div>
      </div>

      <!-- Scores -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('course_scores') }}</label>
        <div class="col-md-7">
          <input v-model="form.scores" type="number" name="scores" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('scores') }">
          <has-error :form="form" field="scores"></has-error>
        </div>
      </div>

      <!-- Course description -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('course_author') }}</label>
        <div class="col-md-7">
          <select v-model="form.author_id"
                  class="form-control"
                  name="author_id"
                  :class="{ 'is-invalid': form.errors.has('author_id') }">
            <option v-for="user in users" v-bind:value="user.id">
              {{ user.name }}
            </option>
          </select>
          <has-error :form="form" field="author_id"></has-error>
        </div>
      </div>

      <!-- Course description -->
      <div class="form-group row">
        <div class="col-md-7 col-md-offset-3">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox"
                     class="form-check-input"
                     name="hidden"
                     v-model="form.hidden">
              {{ $t('course_is_hidden') }}
            </label>
            <has-error :form="form" field="hidden"></has-error>
          </div>
        </div>
      </div>

      <!-- Course is official_course -->
      <div class="form-group row">
        <div class="col-md-7 col-md-offset-3">
          <div class="form-check">
            <label class="form-check-label">
              <input type="checkbox"
                     class="form-check-input"
                     name="official_course"
                     v-model="form.official_course">
              {{ $t('course_is_official') }}
            </label>
            <has-error :form="form" field="official_course"></has-error>
          </div>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-group row">
        <div class="col-md-9 ml-md-auto">
          <v-button type="success" :loading="form.busy">{{ $t('create') }}</v-button>
        </div>
      </div>
    </form>
  </admin-card>

</template>

<script>
  import { mapGetters } from 'vuex'
  import { Form } from 'vform'
  import AdminPage from "../admin-page";

  export default {
    metaInfo () {
      return { title: 'Создать курс' }
    },
    extends: AdminPage,
    data: () => ({
      form: new Form({
        title: '',
        about: '',
        description: '[]',
        lessons_counter: '',
        scores: '',
        author_id: '',
        image: '',
        preview: '',
        partner_logo: '',
        hidden: false,
        official_course: false
      })
    }),
    computed: mapGetters({
      users: 'users/users',
    }),
    methods: {
      async create () {
        const course = await this.$store.dispatch('courses/create', this.form);
        this.$alertify.success(this.$t('admin.global.labels.alert-success'));
        console.log(course);
        this.$router.push({ name: 'admin.course.edit', params: { id: course.id } });
      }
    },
    async beforeMount () {
      this.$store.dispatch('users/fetchAll');
    }
  }
</script>
